export type MyHrTagSeverity = 'success' | 'secondary' | 'info' | 'warn' | 'danger';

export function labelize(value?: string | null): string {
  return (value || '')
    .toLowerCase()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map(part => part.charAt(0).toUpperCase() + part.slice(1))
    .join(' ');
}

export function statusSeverity(value?: string | null): MyHrTagSeverity {
  switch ((value || '').toUpperCase()) {
    case 'APPROVED':
    case 'ACTIVE':
    case 'COMPLETED':
    case 'PUBLISHED':
    case 'READY':
    case 'VERIFIED':
    case 'PAID':
    case 'LOCKED':
      return 'success';
    case 'PENDING':
    case 'SUBMITTED':
    case 'DRAFT':
    case 'IN_PROGRESS':
    case 'ASSIGNED':
      return 'warn';
    case 'REJECTED':
    case 'FAILED':
    case 'EXPIRED':
    case 'CANCELLED':
    case 'BLOCKED':
      return 'danger';
    case 'OPEN':
    case 'NEW':
      return 'info';
    default:
      return 'secondary';
  }
}

export function toDateInputValue(value?: Date | string | null): string | undefined {
  if (!value) {
    return undefined;
  }
  if (typeof value === 'string') {
    return value.slice(0, 10);
  }
  const year = value.getFullYear();
  const month = `${value.getMonth() + 1}`.padStart(2, '0');
  const day = `${value.getDate()}`.padStart(2, '0');
  return `${year}-${month}-${day}`;
}
